const apiConfig = {
  baseURL: "https://restaurant-template.runasp.net",
};

export default apiConfig;